module.exports = "\n<form method=\"POST\" v-on:submit.prevent=\"onSubmit\" name=\"mwc-prevented-form\">\n  <button type=\"submit\" ref=\"submitButton\" style=\"display:none;\"></button>\n  <slot></slot>\n</form>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/prevented_form/index.pug
// module id = 663
// module chunks = 4